module.exports = "pegasus/assets/themelp1/ebook/104.png";